export function LoadingSkeleton() {
  return (
    <div className="bg-white dark:bg-[#1A1A1A] rounded-xl border border-[#E5E7EB] dark:border-[#2A2A2A] overflow-hidden">
      {/* Table Header Skeleton */}
      <div className="border-b border-[#E5E7EB] dark:border-[#2A2A2A] px-6 py-4">
        <div className="flex items-center gap-4">
          <div className="w-5 h-5 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded animate-pulse"></div>
          <div className="flex-1 grid grid-cols-12 gap-4">
            <div className="col-span-3 h-4 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded animate-pulse"></div>
            <div className="col-span-2 h-4 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded animate-pulse"></div>
            <div className="col-span-2 h-4 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded animate-pulse"></div>
            <div className="col-span-2 h-4 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded animate-pulse"></div>
            <div className="col-span-3 h-4 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded animate-pulse"></div>
          </div>
        </div>
      </div>

      {/* Table Rows Skeleton */}
      {[1, 2, 3, 4, 5, 6, 7, 8].map((row) => (
        <div
          key={row}
          className="border-b border-[#E5E7EB] dark:border-[#2A2A2A] last:border-b-0 px-6 py-4"
        >
          <div className="flex items-center gap-4">
            <div className="w-5 h-5 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded animate-pulse"></div>
            <div className="flex-1 grid grid-cols-12 gap-4 items-center">
              {/* Image + Name */}
              <div className="col-span-3 flex items-center gap-3">
                <div className="w-12 h-12 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded-lg animate-pulse"></div>
                <div className="flex-1">
                  <div className="h-4 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded animate-pulse mb-2"></div>
                  <div className="h-3 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded animate-pulse w-2/3"></div>
                </div>
              </div>

              {/* Unit */}
              <div className="col-span-2">
                <div className="h-4 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded animate-pulse w-3/4"></div>
              </div>

              {/* Products */}
              <div className="col-span-2">
                <div className="h-6 w-12 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded-full animate-pulse"></div>
              </div>

              {/* Status */}
              <div className="col-span-2">
                <div className="h-6 w-20 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded-full animate-pulse"></div>
              </div>

              {/* Actions */}
              <div className="col-span-3 flex items-center justify-end gap-2">
                <div className="w-8 h-8 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded-lg animate-pulse"></div>
                <div className="w-8 h-8 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded-lg animate-pulse"></div>
                <div className="w-8 h-8 bg-[#E5E7EB] dark:bg-[#2A2A2A] rounded-lg animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      ))}

      <style jsx="true">{`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
          .animate-pulse {
            animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
          }
        `}</style>
    </div>
  );
}
